import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GameStatus } from 'src/domains/casino/webview/CasinoGames/game-modal/modal-body/modal-success/game-content/game-status/GameStatus';
import { ModalError } from 'src/domains/casino/webview/CasinoGames/game-modal/modal-body/modal-error/ModalError';
import { AppCasinoState, GameDataState } from 'src/domains/casino/state/AppCasino.state';
import {
    GameViewDesktopContainer,
    GameViewMobileContainer,
    PreviewHeader,
    ClosePreviewIcon,
    ExpandIconWrapper,
    GamePreviewTitle,
    LaunchMiniGameBody,
    LaunchMiniGameBodyMobile,
    LaunchMiniGameBodyIframe,
} from './MiniGameModal.style';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';

interface MiniGameModalType {
    appCasinoState: AppCasinoState;
    gameDataState: GameDataState;
}

export const MiniGameModal = observer('MiniGameModal', (props: MiniGameModalType) => {
    // TODO - move this to the main modal if is fullscreen
    const { appCasinoState, gameDataState } = props;

    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);

    const { closeGame, toggleFullScreen } = appCasinoState.gameModalState;
    const desktopVersion = breakpointsState.desktop.isBiggerOrEq === true;

    if (gameDataState.session.status !== 'ready') {
        return null;
    }

    const sessionData = gameDataState.session.value;

    if (sessionData.status !== 200) {
        return (
            <ModalError
                appCasinoState={appCasinoState}
                message={sessionData.payload}
            />
        );
    }

    if (desktopVersion === true) {
        return (
            <GameViewDesktopContainer>
                <PreviewHeader>
                    <GamePreviewTitle>{gameDataState.name}</GamePreviewTitle>

                    <ExpandIconWrapper onClick={toggleFullScreen} />
                    <ClosePreviewIcon onClick={closeGame} />
                </PreviewHeader>

                <LaunchMiniGameBody>
                    <LaunchMiniGameBodyIframe
                        src={sessionData.payload}
                        data-test='game-iframe-mini'
                    />
                </LaunchMiniGameBody>

                <GameStatus
                    appCasinoState={appCasinoState}
                    gameDataState={gameDataState}
                />
            </GameViewDesktopContainer>
        );
    }

    return (
        <GameViewMobileContainer>
            <PreviewHeader>
                <GamePreviewTitle>{gameDataState.name}</GamePreviewTitle>

                <ExpandIconWrapper onClick={toggleFullScreen} />
                <ClosePreviewIcon onClick={closeGame} />
            </PreviewHeader>

            <LaunchMiniGameBodyMobile>
                <LaunchMiniGameBodyIframe
                    src={sessionData.payload}
                    data-test='game-iframe-mini'
                />
            </LaunchMiniGameBodyMobile>

            <GameStatus
                appCasinoState={appCasinoState}
                gameDataState={gameDataState}
            />
        </GameViewMobileContainer>
    );
});
